'use client';
import * as React from 'react';
import { createContext, useState, useMemo } from 'react';

const SelectContext = /*#__PURE__*/createContext({
  activeTab: '',
  setActiveTab: () => {},
  type: 'stroke'
});
const TabsSelectProvider = function SelectProvider({
  children,
  type
}) {
  const [activeTab, setActiveTab] = useState('');
  const value = useMemo(() => ({
    activeTab,
    setActiveTab,
    type
  }), [activeTab, type]);
  return /*#__PURE__*/React.createElement(SelectContext.Provider, {
    value: value
  }, children);
};

export { SelectContext, TabsSelectProvider };
